<template>
    <div v-loading="isLoading">
        <div v-if="agency">
            <div class="form-group">
                <input class="form-control" type="text" v-model="agency.name" placeholder="Название" @change="save">
                <has-error :form="form" field="name" class="d-block"/>
            </div>

            <div class="form-row" v-loading="sources_listing_loading">
                <template v-for="p in platforms">
                    <div class="col-4 mb-3">
                        <AgencyFormPlatform :form="form" :disable="saving" v-model="sources_by_platform[p.id]" :platform="p" :select_options="source_select[p.id]" @update="handlerSourcesUpdate" />
                    </div>
                </template>
            </div>

        </div>
    </div>
</template>

<script>
import Form from "vform";
import Multiselect from "vue-multiselect";
import PlatformHelper from "../../helpers/platform";
import {mapGetters} from "vuex";
import AgencyFormPlatform from "./AgencyFormPlatform.vue";

export default {
    name: "AgencyForm",
    components: {AgencyFormPlatform, Multiselect},
    props: ['agency_id'],
    data: () => ({
        isLoading: true,
        form: new Form({}),
        agency: null,
        sources_by_platform: {},
        sources_listing: [],
        sources_listing_loading: true,
        saving: false,
    }),
    mounted() {
        let self = this;
        this.fetchSourcesListing()
            .then(() => {
                self.fetchAgency();
            })
    },
    computed: {
        source_select() {
            return _.groupBy(_.sortBy(_.cloneDeep(this.sources_listing), 'name'), 'platform_id');
        },
        platforms() {
            let platforms = this.$store.getters['platforms/all'];
            platforms = _.sortBy(platforms, 'name');
            let self = this;
            let list = [];
            platforms.forEach(p => {
                if (self.source_select[p.id]) list.push(p);
            })
            return list;
        },
    },
    methods: {
        save() {
            let self = this;
            self.saving = true;
            let sources = [];
            _.forEach(this.sources_by_platform, (list, p_id) => {
                _.forEach(list, s => {
                    sources.push({
                        id: s.id,
                        streams: [],
                    })
                })
            })
            this.form = new Form({
                name: this.agency.name,
                sources: sources,
            });
            this.form.put('/api/agencies/' + this.agency_id)
                .then(response => {
                    self.$message.success({
                        message: 'Сохранено',
                        duration: 2000,
                    });
                    self.$emit('updated', response.data);
                    self.saving = false;
                })
                .catch(() => {
                    self.isLoading = false;
                    self.saving = false;
                    self.$message.error({
                        message: 'Ошибка, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
        fetchAgency() {
            let self = this;
            self.isLoading = true;
            axios.get('/api/agencies/' + this.agency_id)
                .then(res => {
                    self.agency = res.data;
                    self.loadSources(self.agency.sources);
                    self.isLoading = false;
                })
        },
        loadSources(data) {
            let self = this;
            this.platforms.forEach(p => {
                self.sources_by_platform[p.id] = [];
            })
            _.forEach(_.groupBy(_.cloneDeep(data), 'platform_id'), (list, p_id) => {
                self.sources_by_platform[p_id] = list;
            })
        },
        fetchSourcesListing() {
            let self = this;
            return axios.get('/api/sources?listing_for_agency=1')
                .then(res => {
                    self.sources_listing = res.data;
                    self.sources_listing_loading = false;
                })
        },
        handlerSourcesUpdate(option) {
            this.save();
        },
        selectAll(platform_id) {
            let self = this;
            this.source_select[platform_id].forEach(s => {
                self.sources_by_platform[platform_id].push(s);
            })
            this.source_select[platform_id] = _.values(this.source_select[platform_id]);
        },
        clearAll(platform_id) {
            this.sources_by_platform[platform_id] = [];
        }
    }
}
</script>


<style scoped>

</style>
